'use client';

import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { Text } from "../../atoms/Text/Text.js";
import { wrapper } from "./RequiredIndicator.css.js";
import { requiredLabel } from "./RequiredIndicator.data.js";
function RequiredIndicator({
  disabled = false,
  hidden = false,
  a11yAnnounce = true
}) {
  const textColor = disabled ? "onLight.disabled.muted" : "action.warning.darkest";
  let textJsx = /* @__PURE__ */ jsx(Text, { className: wrapper, color: textColor, "aria-hidden": true, children: "*" });
  if (hidden) textJsx = null;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    textJsx,
    a11yAnnounce && /* @__PURE__ */ jsx(Text, { visuallyHidden: true, children: requiredLabel })
  ] });
}
export {
  RequiredIndicator
};
